import { Injectable } from '@angular/core';
import * as faceapi from '@vladmandic/face-api';
import * as tf from '@tensorflow/tfjs';

@Injectable({
  providedIn: 'root'
})
export class FaceapiService {
modelsLoaded:boolean = false;
modelsWarmed:boolean = false;
inputSize:number = 320;

  constructor() {}

  async loadModels(): Promise<any> {
    if (!this.modelsLoaded) {
      const modelsToLoad = [
        faceapi.nets.tinyFaceDetector.loadFromUri('/assets/models'),    //Deteccion del rostro
        faceapi.nets.faceLandmark68Net.loadFromUri('/assets/models'),   //Puntos de interes
        faceapi.nets.faceRecognitionNet.loadFromUri('/assets/models'),  //Descriptores
        faceapi.nets.faceExpressionNet.loadFromUri('/assets/models'),   //Expresiones
      ];

      await Promise.all(modelsToLoad);
      this.modelsLoaded = true;
      console.log("✅ Modelos optimizados cargados");
      return true;
    }
  }

  async detectFaceWithDescriptors(videoElement: HTMLVideoElement| HTMLCanvasElement) {
    const options = new faceapi.TinyFaceDetectorOptions({ inputSize: this.inputSize, scoreThreshold: 0.4});
    return faceapi.detectSingleFace(videoElement, options)
    .withFaceLandmarks()
    .withFaceDescriptor()
    .withFaceExpressions();
  }

  async detectFaceWithoutDescriptors(videoElement: HTMLVideoElement| HTMLCanvasElement) {
    const options = new faceapi.TinyFaceDetectorOptions({ inputSize: this.inputSize, scoreThreshold: 0.4});
    return faceapi.detectSingleFace(videoElement, options)
    .withFaceLandmarks()
    .withFaceExpressions();
  }

  async detectFaceStepMode(videoElement: HTMLVideoElement | HTMLCanvasElement, modelsToUse: number = 4) {
    const options = new faceapi.TinyFaceDetectorOptions({ inputSize: this.inputSize, scoreThreshold: 0.4 });
    
    let detection:any = faceapi.detectSingleFace(videoElement, options);
    
    if (modelsToUse >= 2) detection = detection.withFaceLandmarks();
    if (modelsToUse == 3){ 
      detection = detection.withFaceExpressions();
      this.modelsWarmed = true;
    }
    if (modelsToUse == 4){
      detection = detection.withFaceDescriptor().withFaceExpressions();
      this.modelsWarmed = true;
    }

    return detection;
  }

  async warmupDetection(howManyModels:number = 3) {
    const img = new Image();
    img.src = './assets/images/maia/warmup-face.jpg';

    return new Promise((resolve, reject) => {
      img.onload = async () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (ctx) {
            ctx.drawImage(img, 0, 0);
          }
          const detection = await this.detectFaceStepMode(canvas, howManyModels);
          resolve(detection);
        } catch (error) {
          console.error("Warm-up failed:", error);
          reject(error);
        }
      };
  
      img.onerror = (e) => reject(`Error loading warm-up image: ${e}`);
    });
  }
}
